import React from "react";

const fmt = (iso) =>
  iso
    ? new Date(iso).toLocaleString("en-GB", { day: "numeric", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" })
    : "";

const show = (value, unit = "") => (unit.startsWith("₹") ? `₹${value}${unit.slice(1)}` : `${value}${unit ? ` ${unit}` : ""}`);

// History of the customer's rate change requests: both the MV Load rate and the customer's proposal
const RequestChangesList = ({ requests }) => {
  if (!requests?.length) return null;
  return (
    <div className="ob_card">
      <div className="ob_card_head">
        <h5>Your Change Requests</h5>
        <p>MV Load's rate and your proposed rate are both kept on every request</p>
      </div>
      {[...requests].reverse().map((r) => (
        <div key={r.id} className="ob_request">
          <div className="ob_request_head">
            <span className={`ob_pill ${r.status}`}>{r.status === "pending" ? "Under review" : "Reviewed"}</span>
            <span className="when">
              Sent {fmt(r.submittedAt)}
              {r.resolvedAt ? ` · reviewed ${fmt(r.resolvedAt)}` : ""}
            </span>
          </div>
          <p className="reason">“{r.reason}”</p>
          {r.note && <p className="reason">MV Load: {r.note}</p>}
          <table className="ob_charges changes">
            <thead>
              <tr>
                <th>Item</th>
                <th>MV Load rate</th>
                <th>Your rate</th>
              </tr>
            </thead>
            <tbody>
              {r.changes.map((c) => (
                <tr key={c.kind + c.key}>
                  <td>
                    {c.group} · {c.label}
                  </td>
                  <td>{show(c.current, c.unit)}</td>
                  <td>
                    <strong>{show(c.proposed, c.unit)}</strong>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ))}
    </div>
  );
};

export default RequestChangesList;
